export default "__VITE_ASSET__C5LGUvb2__"